import { render, staticRenderFns } from "./ServicesBG.vue?vue&type=template&id=5d82c856&scoped=true&"
import script from "./ServicesBG.vue?vue&type=script&lang=js&"
export * from "./ServicesBG.vue?vue&type=script&lang=js&"
import style0 from "./ServicesBG.vue?vue&type=style&index=0&id=5d82c856&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d82c856",
  null
  
)

export default component.exports